import React, { useRef } from 'react';
import { ReactComponent as SmallGridIcon } from "../../Icons/grid.svg";
import ViewMenuItems from "./ViewMenuItems";
import MainFilterDropdownMenuWithButton from "./MainFilterDropdownMenuWithButton";
import EscapeListener from '../Utils/EscapeListener';
import TabAwayListener from '../Utils/TabAwayListener';

export default function ViewMenuWithButton({ label = "View", excludeGridView=false, ...props}) {

    const [open, setOpen] = React.useState(false);

    const anchorRef = useRef(null);
    const viewMenuRef = useRef(null);

    return (
        <MainFilterDropdownMenuWithButton open={open} anchorRef={anchorRef} handleToggle={() => setOpen(open => !open)} buttonIcon={SmallGridIcon} buttonLabel={label}>
             <EscapeListener enabled={open} onKeyPress={() => {
                setOpen(false);
                if(anchorRef.current) 
                    anchorRef.current.focus();
            }}>
                <TabAwayListener tabRef={viewMenuRef} enabled={open} tabAwayHandler={() => setOpen(false)}>
                    <div ref={viewMenuRef}>
                        <ViewMenuItems onItemClick={() => setOpen(false)} excludeGridView={excludeGridView}/>
                    </div>
                </TabAwayListener>
            </EscapeListener>
        </MainFilterDropdownMenuWithButton>

    );
}